import React from 'react';
import { useOrderHistory } from '../context/OrderHistoryContext';
import { Link } from 'react-router-dom';

const OrderHistoryPage = () => {
  const { orderHistory } = useOrderHistory();

  return (
    <div className="main-container order-history-page">
      <section style={{
        padding: '3rem 0',
        maxWidth: '900px',
        margin: '0 auto'
      }}>
        <h1 style={{
          fontSize: '2.5rem',
          fontWeight: '900',
          color: '#008751',
          marginBottom: '2rem',
          textAlign: 'center'
        }}>
          📦 Order History
        </h1>
        {orderHistory.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '3rem 1rem',
            background: 'white',
            borderRadius: '20px',
            boxShadow: '0 8px 25px rgba(0,0,0,0.07)'
          }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🕒</div>
            <h3 style={{ color: '#008751', marginBottom: '1rem' }}>No Orders Yet</h3>
            <p>When you place an order, it will appear here for easy tracking.</p>
          </div>
        ) : (
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr',
            gap: '2rem'
          }}>
            {orderHistory.map(order => (
              <div key={order.id} style={{
                background: 'white',
                borderRadius: '20px',
                padding: '2rem',
                boxShadow: '0 8px 25px rgba(0,0,0,0.07)',
                border: '2px solid #f8f9fa'
              }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '1rem'
                }}>
                  <div>
                    <strong style={{ color: '#008751' }}>Order #{order.id}</strong>
                    <div style={{ fontSize: '0.95rem', color: '#6b7280' }}>{order.date}</div>
                  </div>
                  <div>
                    <span style={{
                      background: order.paymentMethod === 'card' ? '#22c55e' : '#fb923c',
                      color: 'white',
                      padding: '0.4rem 1rem',
                      borderRadius: '15px',
                      fontSize: '0.9rem',
                      fontWeight: '700'
                    }}>
                      {order.paymentMethod === 'card' ? 'Paid (Paystack)' : 'Cash on Delivery'}
                    </span>
                  </div>
                </div>
                <div style={{ marginBottom: '1rem' }}>
                  <strong>Items:</strong>
                  <ul style={{ margin: 0, paddingLeft: '1.2rem' }}>
                    {order.items.map(item => (
                      <li key={item.id}>
                        {item.name} x {item.quantity} — ₦{(item.price * item.quantity).toLocaleString()}
                      </li>
                    ))}
                  </ul>
                </div>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '0.7rem'
                }}>
                  <div>
                    <strong>Total:</strong> ₦{order.total.toLocaleString()}
                  </div>
                  <div>
                    <strong>Address:</strong> {order.address}
                  </div>
                </div>
                {order.paystackRef && (
                  <div style={{
                    fontSize: '0.9rem',
                    color: '#6b7280',
                    marginTop: '0.5rem'
                  }}>
                    Paystack Ref: {order.paystackRef}
                  </div>
                )}
                <Link
                  to={`/orders/${order.id}`}
                  style={{
                    background: '#008751',
                    color: 'white',
                    padding: '0.5rem 1.2rem',
                    borderRadius: '15px',
                    textDecoration: 'none',
                    fontWeight: '700',
                    marginTop: '1rem',
                    display: 'inline-block'
                  }}
                >
                  Track Order
                </Link>
              </div>
            ))}
          </div>
        )}
      </section>
      <style>{`
        .main-container.order-history-page {
          box-sizing: border-box;
          width: 100%;
          max-width: 100vw;
          overflow-x: hidden;
        }
        @media (max-width: 600px) {
          .main-container.order-history-page section {
            padding: 1rem 0 !important;
          }
        }
      `}</style>
    </div>
  );
};

export default OrderHistoryPage;